export function getReportList (){
  return [{type:1,content:'内容が低俗'},
          {type:2,content:'明らかな広告'},
          {type:16,content:'誤字が多い'},
          {type:4,content:'重複した内'},
          {type:8,content:'フィッシング'},
          {type:32,content:'その他'}]
}
export function isEmptyObject (e) {
  let t
  for (t in e) {
    return !1
  }
  return !0
}
/**
 * 获取当前时间戳
 */
export function getNow () {
  const nowTimestamp = Date.parse(new Date())
  return nowTimestamp
}
export function getDate () {
  let date = new Date()
  let  year = date.getFullYear();
  let  month = date.getMonth() + 1;
  let  day = date.getDate();
  month = (month > 9) ? month : ("0" + month);
  day = (day < 10) ? ("0" + day) : day;
  let today = year + "-" + month + "-" + day;
  return today
}
/**
 * 时间戳赚时间   几小时前   日期
 * @param timestamp
 * @returns {string}
 */
export function timeToStr (timestamp) { // 时间戳转帖子显示的事件
  timestamp = timestamp / 1000
  const nowTimestamp = Date.parse(new Date()) / 1000 + 60
  let s = nowTimestamp - timestamp
  let h = Math.floor(s / 3600)
  if (h < 13 ) {
    if (h === 0) {
      return `${Math.floor(s / 60)}分前`
    } else {
      return `${h}時間前`
    }
  }
  let date = new Date(timestamp * 1000)
  let min = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
  let nowDate = new Date(nowTimestamp * 1000)
  if (date.getFullYear() === nowDate.getFullYear() && date.getMonth() === nowDate.getMonth() && date.getDate() === nowDate.getDate()) {
    return `${date.getHours()}:${min}`
  }
  if (date.getFullYear() === nowDate.getFullYear() && date.getMonth() === nowDate.getMonth() && (date.getDate() + 1) === nowDate.getDate()) {
    return `昨日${date.getHours()}:${min}`
  }
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
}

// 判断元素是否在数组里
export function inArray (needle, haystack) {
  if (!haystack) {
    return false
  }
  let n = haystack.length
  for (let i = 0; i < n; ++i) {
    if (haystack[i] === needle) {
      return true
    }
  }
  return false
}
/**
 * 获取当前时间
 * @param content
 */
export function getTime(timestamp){
  var date = new Date(timestamp);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var seconds = date.getSeconds();
  var time = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  return time;
}

/**
 * 预览
 * @param content
 */
export function previewHtml(title = '', content) {
  if (window.previewWindow) {
    window.previewWindow.close();
  }
  const templete = `
      <!Doctype html>
      <html>
        <head>
          <title>内容预览</title>
          <style>
            html,body{
              height: 100%;
              margin: 0;
              padding: 0;
              overflow: auto;
              background-color: #f1f2f3;
            }
            .container{
              box-sizing: border-box;
              width: 1000px;
              max-width: 100%;
              min-height: 100%;
              margin: 0 auto;
              padding: 30px 20px;
              overflow: hidden;
              background-color: #fff;
              border-right: solid 1px #eee;
              border-left: solid 1px #eee;
            }
            .container img,
            .container audio,
            .container video{
              max-width: 100%;
              height: auto;
            }
          </style>
        </head>
        <body>
            <div class="container">
              <h1>${title}</h1> 
              <br>
               ${content}
             </div>
        </body>
      </html>
    `;
  window.previewWindow = window.open();
  window.previewWindow.document.write(templete);
}